import React, { useEffect, useState, useRef, useCallback } from "react";
// import { Row, Col, Button, ButtonGroup } from "reactstrap";
import Box from '@mui/material/Box';
import { TextField, FormControlLabel, FormHelperText,
  Radio, RadioGroup, Grid, Divider, TextareaAutosize, 
  FormGroup, Checkbox } from '@mui/material';
import { styled } from '@mui/system';
import _ from 'lodash';

const FormItem = (props) => {

  const [rSelected, setRSelected] = useState(null);
  const [inputTextErrors, setInputTextErrors] = useState({});
  const [inputTextValues, setInputTextValues] = useState({});
  const [clearTextField, setClearTextField] = useState(false);

  const q_type = props.q_type;
  const question = props.question;
  const show_question = props.showQuestion;
  const radio = props.radio;
  const radio_dependency = props.radioDependency;
  const radio_text = props.radioText;
  const text_box = props.textBox;
  const text_box_type = props.textBoxType;
  const col_size = props.size;
  const required = props.required;
  const current_step = props.currentStep;
  const update = props.update;
  const checkbox = props.checkbox;
  const checkbox_text = props.checkboxText;
  const text_area = props.textArea;
  const autofill_fields = props.autofill;

  // useEffect(() => {
  //   const hasRequired = _.some(required, (val) => val === true);
  // }, [required]);

  const hasRequired = _.some(required, (val) => val === true);

  const onValueChange = useCallback((name, value, contextKey, key, clear = false) => {
    const changePayload = {
      [key]: value
    };

    update(
      name,
      changePayload,
      q_type,
      contextKey,
      clear
    );
  }, [update, q_type]);

  // const onValueChange = (name, value, contextKey, key, clear=false) => {
  //   const changePayload = {
  //     [key]: value
  //   };
  //   update(
  //       name,
  //       changePayload,
  //       q_type,
  //       contextKey,
  //       clear
  //   );
  // };

  const field_type_map = {"text": "text", "tel": "tel", 
    "email": "email", "number": "number", "postal": "number"}

  const onInputChanged = (event, fieldName) => {
    let {name, value, type, checked } = event.target;
    // console.log(fieldName);
    if (rSelected && rSelected !== radio_dependency[0]) {
        setInputTextValues({
          ...inputTextValues,
          [radio_dependency[0]]: ""
        });
        // console.log("Input blocked: Correct radio not selected.");
        // return; 
    }
    setInputTextValues({
      ...inputTextValues,
      [fieldName]: value
    });
    const data_field_type = event.target.dataset.fieldType;

    let regex = /[\s\S]*/;
    let key = "text";
    switch (type) {
      case "text":
        // console.log("text is being edited");
        regex = /^[a-zA-Z0-9,.\s'()\-]*$/;
        break;
      case "number":
        if (data_field_type === "postal"){
          regex = /^\d{4}$/;
        }else{
          regex = /^\d+(\.\d{1,3})?$/;
        }
        // console.log("number is being edited");
        break;
      case "email":
        regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
        // console.log("email is being edited");
        break;
      case "tel":
        regex = /^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;
        // console.log("phone is being edited");
        break;
      case "radio":
        // console.log("radio is being edited");
        key = "radio";
        // regex = /[\s\S]*/;
        break;
      case "checkbox":
        // console.log("checkbox is being edited");
        key = "checkbox";
        value = checked;
        // regex = /[\s\S]*/;
        break;
      // case "checkbox":
      //   console.log("radio is being edited");
      //   key = "radio";
      //   // regex = /[\s\S]*/;
      //   break;
      // case "postal":
      //   regex = /^\d{4}$/;
      //   console.log("postal is being edited");
      //   break;

      default:
        // console.log(`No valid ${type}.`);
    }

    if (!_.isEmpty(value) && !regex.test(value)){
      setInputTextErrors((inputTextErrors) => ({
        ...inputTextErrors,
        [name]: true
      }));
      onValueChange(name, '', question, key);
    }
    else if (_.isEmpty(value)){
      setInputTextErrors((inputTextErrors) => ({
        ...inputTextErrors,
        [name]: true
      }));
      onValueChange(name, value, question, key);
    }
    else {
      setInputTextErrors((inputTextErrors) => ({
        ...inputTextErrors,
        [name]: false
      }));
      onValueChange(name, value, question, key);
    }
  };

  const handleHelperText = (text_name, err) => {
    if (err){
      return (`please enter a valid ${text_name.toLowerCase()}`);
    }
    return '';
  };

  const CustomHelperText = styled(FormHelperText)({
    minHeight: "2em",
    lineHeight: "1em",
    margin: 0,
    color: "red",
    marginTop: "5px"
  });

  const hasEmailValue = _.some(autofill_fields, (item) => !_.isNil(item.email) && item.email !== '');
  const hasBMIValue = _.some(autofill_fields, (item) => !_.isNil(item.bmi) && item.bmi !== '');

  const isFieldHiddenByRadio = radio_dependency && rSelected === radio_dependency;
  // console.log(!_.isNil(_.get(autofill_fields, '[0].email')));
  // console.log(autofill_fields);

  const questionsRef = useRef(question);
  const radioDependencyRef = useRef(radio_dependency);
  const textBoxRef = useRef(text_box);

  // useEffect(() => {
  //   // console.log(radio_dependency[0]);
  //   // console.log(question);
  //   // console.log(rSelected);
  //   // console.log( rSelected !== radio_dependency[0]);
  //   if (!_.isEmpty(radioDependencyRef.current)) {
  //     onValueChange(radioDependencyRef.current[0], "", questionsRef.current, "text");
  //   }
  // }, [clearTextField, onValueChange]); 


  useEffect(() => {
    // console.log(radioDependencyRef.current[0]);
    // console.log(questionsRef.current);
    // console.log(rSelected);
    // console.log( rSelected !== radioDependencyRef.current[0]);
    if (!_.isEmpty(radioDependencyRef.current)) {
      if (rSelected !== radioDependencyRef.current[0]){
        setClearTextField(true);
        onValueChange(textBoxRef.current[0], "", questionsRef.current, "text");
      } else {
        setClearTextField(false);
      }
      // onValueChange(radio_dependency[0], "", question, "text");
    }
  }, [rSelected, onValueChange]); 

  const hasAutofilled = useRef(false);

  const externalBmi = _.get(autofill_fields, '[0].bmi');
  useEffect(() => {
    if (externalBmi && question === "BMI, (calculation automatic)") {
      onValueChange("BMI", externalBmi, question, "text");
    }
  },[externalBmi, question, onValueChange]);


  useEffect(() => {
    const externalEmail = _.get(autofill_fields, '[0].email');

    
    if (hasAutofilled.current) return;

    if (externalEmail && question === "Contact Details") {
      onValueChange("Email Address", externalEmail, question, "text");
      hasAutofilled.current = true; 
    }
    // if (externalBmi && question === "BMI, (calculation automatic)") {
    //   onValueChange("BMI", externalBmi, question, "text");
    //   // hasAutofilled.current = true; 
    // }    
  }, [autofill_fields, question, onValueChange]);

  return (
    <div className="form-item-div" >
        {show_question ?
        <p className="trial-question">
          {question} {hasRequired && <span style={{ color: "red", marginLeft: "4px", fontSize: "16px" }}>*</span>}
        </p>
        : (<></>)}
        <RadioGroup
          aria-labelledby="row-radio-buttons-group-label"
          name="radio-selection"
          sx={{
            display: 'flex',
            // If more than 2 items, use column, otherwise use row
            flexDirection: radio && radio.length > 2 ? 'column' : 'row',
            justifyContent: 'center',
            alignItems: radio && radio.length > 2 ? 'flex-start' : 'center', // Align left if vertical
            margin: '0 auto',
            width: 'fit-content' // Keeps it centered properly
          }}
          onChange={onInputChanged}
        >
          {radio ? (
            radio.map((q, i) => (
              <FormControlLabel
                key={i}
                label={q}
                value={q}
                control={<Radio />}
                onClick={() => setRSelected(q)}
                sx={{
                  // Add some spacing if they are listed vertically
                  marginBottom: radio.length > 2 ? '8px' : '0'
                }}
                slotProps={{
                    typography: {
                      sx: {
                        fontFamily: 'NEXT_ART_SemiBold, sans-serif',
                        fontSize: '12px',
                        maxWidth: '100px',
                        whiteSpace: 'normal',
                        // wordBreak: 'break-word',
                        lineHeight: '1.4',
                        textAlign: 'left',
                      },
                    },
                  }}
              />
            ))
          ) : null}
        </RadioGroup>

        {checkbox ? (checkbox.map((q, i) => (
          <FormGroup
            onChange={onInputChanged}
          >
            <FormControlLabel 
              required={required[i]} 
              control={<Checkbox name="checkbox-selection"/>} 
              label={checkbox_text[i]} 
              slotProps={{
                typography: {
                  sx: {
                    fontSize: "12px",
                    color: "black",
                    textAlign: "center",
                    width: "100%",
                    fontFamily: 'NEXT_ART_SemiBold, sans-serif',
                  }
                }
              }}
            />
          </FormGroup>
        ))
        ):(<></>)}
        <Box
          component="form"
          sx={{ '& > :not(style)': { m: 0 }, flexGrow: 1 }}
          noValidate
          autoComplete="off"
          onChange={onInputChanged}
        >
          <Grid 
            container 
            spacing={1}
            sx={{
              justifyContent: "center",
              alignItems: "center",
            }}
            direction={"row"}
          >
            {text_box ? (text_box.map((q, i) => (
            <Grid
              size={col_size}
              sx={{
                textAlign: "center",
                // width: "100%",
                // maxWidth: '200px'
                justifySelf: "center"
              }}
            >
              <TextField 
                value={clearTextField ? "":
                  (text_box_type[i] === 'email' && _.get(autofill_fields, '[0].email')) 
                    ? _.get(autofill_fields, '[0].email') 
                    : q === "BMI" ? _.get(autofill_fields, '[0].bmi') : (inputTextValues[q])
                }
                disabled={clearTextField ? true: 
                  (text_box_type[i] === 'email' && 
                  Boolean(_.get(autofill_fields, '[0].email'))) || q === "BMI"
                }

                fullWidth
                error={inputTextErrors[q]}
                required={required[i]}
                id="outlined-basic"  
                variant="outlined"
                name={q} 
                placeholder={text_box[i]}
                sx={{
                  '& .MuiInputBase-input': {
                    color: '#000000',
                    WebkitTextFillColor: '#000000 !important'
                  },
                }}
                slotProps={{
                  typography: {
                    sx: {
                      fontSize: "14px",
                      color: "black",
                      textAlign: "center",
                      width: "100%"
                    }
                  },
                  htmlInput: {
                    'data-field-type': text_box_type[i],
                    maxLength: 50,
                  },
                }}
                type={field_type_map[text_box_type[i]]}
              />
              <CustomHelperText className="helperText">
                {handleHelperText(text_box[i], inputTextErrors[q]) || " "}
              </CustomHelperText>
            </Grid>
            ))
            ) : (<></>)}
            {!_.isEmpty(text_area) ? (text_area.map((q, i) => (
              <TextareaAutosize
                name="text-area"
                maxRows={9}
                placeholder=""
                defaultValue=""
                style={{ width: 400 }}
                sx={{
                  '& .MuiInputBase-input': {
                    color: '#000000',
                    WebkitTextFillColor: '#000000 !important',
                  },
                }}
                onChange={onInputChanged}
              />
            ))
            ):(<></>)}
          </Grid>
        </Box>
    </div>
  );
};

export default FormItem;